import React, {Component, PropTypes} from 'react';
import {Col} from 'react-bootstrap';
import styled from 'styled-components';

import Contract from './Contract';
import {getContractList } from '../../api/api';

const Root = styled(Col)`
  padding: 0;
  margin-bottom: 80px;
`;

const Title = styled.div`
  border-bottom: 2px solid #d8d8d8;
  font-weight: bold;
  color: black;
  padding-bottom: 8px;
`;

class ContractInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      contractList: [],
    };
  }

  componentDidMount() {
    this.loadContractList();
  }

  loadContractList = () => {
    let self = this;
    getContractList(this.props.patientId, (err, result) => {
      if (err) {
        Messenger().post({
          type: 'error',
          message: `${err.message} (${err.statusCode})`,
          showCloseButton: true,
        });
      } else {
        this.setState({
          contractList: result
        });
      }
    });
  }

  handleContractUpdated = () => {
    this.loadContractList();
  }


  render() {
    return (
        <Root xs={12}>
          <Title>Contract Info</Title>
          {
            this.state.contractList.length === 0 ? (
                <div>It's not exist.</div>
            ) : (
                this.state.contractList.map((contract, idx) => (
                    <Contract
                        expand={idx == 0}
                        key={contract.contractId}
                        contract={contract}
                        patientId={this.props.patientId}
                        hideLoading={this.props.hideLoading}
                        showLoading={this.props.showLoading}
                        contractUpdated={this.handleContractUpdated}
                    />
                ))
            )
          }
        </Root>
    );
  }
}

ContractInfo.propTypes = {
  patientId: PropTypes.number.isRequired,
};

export default ContractInfo;



// WEBPACK FOOTER //
// ./src/routes/patient/ContractInfo.js